import { View, Text, Image } from "@react-pdf/renderer";
import { parseDate } from "helpers/date";
import { IAbnNotice } from "types/AbnNotice/AbnNotice";

import { styles } from "../styles";

export function Signature({
  activeAbnNotice,
}: {
  activeAbnNotice?: IAbnNotice | null;
}) {
  return (
    <View style={{ marginTop: 2, display: "flex", flexDirection: "column" }}>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          borderWidth: 1,
          borderColor: "#000",
        }}
      >
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "50%",
            borderRightWidth: 1,
            padding: 4,
            borderColor: "#000",
          }}
        >
          <Text
            style={{
              ...styles.bodyText,
              fontSize: 12,
              fontFamily: "Helvetica-Bold",
            }}
          >
            I. Signature:
          </Text>
          {activeAbnNotice?.signatureUrl && (
            <Image
              style={{ width: 100, height: "auto" }}
              src={activeAbnNotice?.signatureUrl}
            />
          )}
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "50%",
            padding: 4,
          }}
        >
          <Text
            style={{
              ...styles.bodyText,
              fontSize: 12,
              fontFamily: "Helvetica-Bold",
            }}
          >
            J. Date:
          </Text>
          {activeAbnNotice?.createdAt && (
            <Text style={{ ...styles.bodyText, fontSize: 12, marginBottom: 0 }}>
              {parseDate(activeAbnNotice?.createdAt)}
            </Text>
          )}
        </View>
      </View>
      <View style={{ marginTop: 5, display: "flex", flexDirection: "column" }}>
        <Text
          style={{
            ...styles.bodyText,
            fontFamily: "Helvetica-Bold",
          }}
        >
          {`You have the right to get Medicare information in an accessible format, like large print, Braille, or audio. You also have the right to file a compliant if you feel you've been discriminated against. Visit Medicare.gov/about-us/accessibility-nondiscrimination-notice.`}
        </Text>
        <Text style={{ ...styles.bodyText, fontSize: 9 }}>
          According to the Paperwork Reduction Act of 1995, no persons are
          required to respond to a collection of information unless it displays
          a valid OMB control number. The valid OMB control number for this
          information collection is 0938-0566. The time required to complete
          this information collection is estimated to average 7 minutes per
          response, including the time to review instructions, search existing
          data resources, gather the data needed, and complete and review the
          information collection. If you have comments concerning the accuracy
          of the time estimate or suggestions for improving this form, please,
          write to: CMS, 7500 Security Boulevard, Attn: PRA Reports Clearance
          Officer, Baltimore, Maryland 21244-1850.
        </Text>
        <View
          style={{
            height: 3,
            backgroundColor: "black",
            marginTop: 10,
            marginBottom: 2,
          }}
        />
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 2,
            justifyContent: "space-between",
            paddingLeft: 5,
            paddingRight: 5,
          }}
        >
          <Text style={{ ...styles.bodyText, fontSize: 12 }}>
            Form CMS-R-131 (Exp.01/31/2026)
          </Text>
          <Text style={{ ...styles.bodyText, fontSize: 12 }}>
            Form Approved OMB No. 0938-0566
          </Text>
        </View>
      </View>
    </View>
  );
}
